export default __webpack_public_path__ + "static/media/Vector.19ba2232.svg";